import { PageContainer } from '@pukka/ui-components';
import { useFlagWithFallback } from '@pukka/unleash';

import { BrandsState } from './Brands.state';
import { BrandsActionBar } from './BrandsActionBar';
import { BrandsForm } from './BrandsForm';
import { BrandsInfoBanner } from './BrandsInfoBanner';
import { BrandsTable } from './BrandsTable';

function Brands() {
  const [enablePrincipalBrands] = useFlagWithFallback('backoffice-principal-brands');
  const { useBrands } = BrandsState;

  useBrands();

  // remove soon
  /* istanbul ignore next */
  if (!enablePrincipalBrands) {
    window.location.replace('/library/brands');

    return null;
  }

  return (
    <PageContainer className="!pb-0">
      <BrandsActionBar />

      <BrandsForm />

      <BrandsInfoBanner />

      <BrandsTable withCheckbox />
    </PageContainer>
  );
}

export default Brands;
